<app-page-shell>
  <app-page-hero eyebrow="Transport Planning" title="Bulk Planning Runs"
    subtitle="Search planning runs by demand, project, assigned fleet, route, and execution outcome.">
    <div actions>
      <p-button label="Refresh" icon="pi pi-refresh" severity="secondary" [outlined]="true" (onClick)="refresh()"></p-button>
      <p-button label="Truck Plans" icon="pi pi-list" severity="secondary" [outlined]="true" routerLink="/transport-planning/plans"></p-button>
      <p-button label="Release Pool" icon="pi pi-list" severity="secondary" [outlined]="true" routerLink="/transport-planning/releases"></p-button>
      <p-button label="Run Bulk Plan" icon="fa-solid fa-route" routerLink="/transport-planning/bulk-planning/new"></p-button>
    </div>
  </app-page-hero>

  <app-page-search-panel title="Search Bulk Planning Runs" [activeFilters]="activeFilterCount()"
    [resultText]="totalRecords + ' matching runs'" [collapsed]="false"
    (search)="applyFilters()" (clear)="clearFilters()">
    <div class="filter-grid" (keyup.enter)="applyFilters()">
      <div class="filter-field wide"><p-inputGroup><p-inputGroupAddon><i class="pi pi-search"></i></p-inputGroupAddon><p-iftaLabel>
        <input pInputText id="bulkSearch" type="search" [(ngModel)]="filters.search" placeholder="Run, release, project, driver, plate, or shipment" />
        <label for="bulkSearch">Search runs, demand, fleet, and shipments</label>
      </p-iftaLabel></p-inputGroup></div>
      <div class="filter-field"><p-inputGroup><p-inputGroupAddon><i class="pi pi-hashtag"></i></p-inputGroupAddon><p-iftaLabel>
        <input pInputText id="bulkRunNumber" [(ngModel)]="filters.runNumber" placeholder="BPR/…" />
        <label for="bulkRunNumber">Run number</label>
      </p-iftaLabel></p-inputGroup></div>
      <div class="filter-field"><p-inputGroup><p-inputGroupAddon><i class="pi pi-info-circle"></i></p-inputGroupAddon><p-iftaLabel>
        <p-multiSelect inputId="bulkStatuses" [options]="statusOptions" [(ngModel)]="filters.statuses" optionLabel="label" optionValue="value"
          placeholder="All statuses" display="chip" [showClear]="true" appendTo="body" styleClass="w-full"></p-multiSelect>
        <label for="bulkStatuses">Status</label>
      </p-iftaLabel></p-inputGroup></div>
      <div class="filter-field"><p-inputGroup><p-inputGroupAddon><i class="pi pi-sliders-h"></i></p-inputGroupAddon><p-iftaLabel>
        <input pInputText id="bulkProfile" [(ngModel)]="filters.profile" placeholder="Profile name" />
        <label for="bulkProfile">Planning profile</label>
      </p-iftaLabel></p-inputGroup></div>
      <div class="filter-field"><p-inputGroup><p-inputGroupAddon><i class="pi pi-bolt"></i></p-inputGroupAddon><p-iftaLabel>
        <p-select inputId="bulkTrigger" [options]="triggerOptions" [(ngModel)]="filters.triggerType" optionLabel="label" optionValue="value"
          appendTo="body" styleClass="w-full"></p-select>
        <label for="bulkTrigger">Trigger</label>
      </p-iftaLabel></p-inputGroup></div>
      <div class="filter-field"><p-inputGroup><p-inputGroupAddon><i class="pi pi-list"></i></p-inputGroupAddon><p-iftaLabel>
        <input pInputText id="bulkRelease" [(ngModel)]="filters.release" placeholder="Release / order number" />
        <label for="bulkRelease">Release or source number</label>
      </p-iftaLabel></p-inputGroup></div>
      <div class="filter-field"><p-inputGroup><p-inputGroupAddon><i class="pi pi-briefcase"></i></p-inputGroupAddon><p-iftaLabel>
        <input pInputText id="bulkProject" [(ngModel)]="filters.project" placeholder="Project name or number" />
        <label for="bulkProject">Project</label>
      </p-iftaLabel></p-inputGroup></div>
      <div class="filter-field"><p-inputGroup><p-inputGroupAddon><i class="pi pi-user"></i></p-inputGroupAddon><p-iftaLabel>
        <input pInputText id="bulkDriver" [(ngModel)]="filters.driver" placeholder="Assigned driver name" />
        <label for="bulkDriver">Driver</label>
      </p-iftaLabel></p-inputGroup></div>
      <div class="filter-field"><p-inputGroup><p-inputGroupAddon><i class="pi pi-truck"></i></p-inputGroupAddon><p-iftaLabel>
        <input pInputText id="bulkVehicle" [(ngModel)]="filters.vehicle" placeholder="Plate or registration" />
        <label for="bulkVehicle">Vehicle</label>
      </p-iftaLabel></p-inputGroup></div>
      <div class="filter-field"><p-inputGroup><p-inputGroupAddon><i class="pi pi-map-marker"></i></p-inputGroupAddon><p-iftaLabel>
        <input pInputText id="bulkOrigin" [(ngModel)]="filters.origin" placeholder="Pickup location" />
        <label for="bulkOrigin">Pickup</label>
      </p-iftaLabel></p-inputGroup></div>
      <div class="filter-field"><p-inputGroup><p-inputGroupAddon><i class="pi pi-map"></i></p-inputGroupAddon><p-iftaLabel>
        <input pInputText id="bulkDestination" [(ngModel)]="filters.destination" placeholder="Dropoff location" />
        <label for="bulkDestination">Dropoff</label>
      </p-iftaLabel></p-inputGroup></div>
      <div class="filter-field"><p-inputGroup><p-inputGroupAddon><i class="pi pi-calendar"></i></p-inputGroupAddon><p-iftaLabel>
        <input pInputText id="bulkHorizonFrom" type="date" [(ngModel)]="filters.horizonFrom" />
        <label for="bulkHorizonFrom">Horizon from</label>
      </p-iftaLabel></p-inputGroup></div>
      <div class="filter-field"><p-inputGroup><p-inputGroupAddon><i class="pi pi-calendar"></i></p-inputGroupAddon><p-iftaLabel>
        <input pInputText id="bulkHorizonTo" type="date" [(ngModel)]="filters.horizonTo" />
        <label for="bulkHorizonTo">Horizon to</label>
      </p-iftaLabel></p-inputGroup></div>
      <div class="filter-field"><p-inputGroup><p-inputGroupAddon><i class="pi pi-calendar-plus"></i></p-inputGroupAddon><p-iftaLabel>
        <input pInputText id="bulkCreatedFrom" type="date" [(ngModel)]="filters.createdFrom" />
        <label for="bulkCreatedFrom">Created from</label>
      </p-iftaLabel></p-inputGroup></div>
      <div class="filter-field"><p-inputGroup><p-inputGroupAddon><i class="pi pi-calendar-times"></i></p-inputGroupAddon><p-iftaLabel>
        <input pInputText id="bulkCreatedTo" type="date" [(ngModel)]="filters.createdTo" />
        <label for="bulkCreatedTo">Created to</label>
      </p-iftaLabel></p-inputGroup></div>
    </div>
  </app-page-search-panel>

  <app-page-metric-strip [metrics]="summaryMetrics()"></app-page-metric-strip>
  @if (message) { <div class="notice" role="alert">{{ message }}</div> }

  <app-page-data-panel title="Run Directory" subtitle="Fleet assignments come from the selected scenario, or the first scenario before selection."
    [resultText]="totalRecords + ' runs'">
    <p-table [value]="runs" [loading]="loading" [lazy]="true" (onLazyLoad)="load($event)"
      [paginator]="true" [rows]="25" [rowsPerPageOptions]="[10, 25, 50, 100]" [first]="first"
      [totalRecords]="totalRecords" [rowHover]="true" [resizableColumns]="true" dataKey="runId"
      sortField="createdAt" [sortOrder]="-1" responsiveLayout="scroll"
      [tableStyle]="{ 'min-width': '120rem' }" styleClass="workspace-table bulk-directory-table">
      <ng-template pTemplate="header">
        <tr class="group-head"><th colspan="2">Run</th><th colspan="2">Order demand</th>
          <th colspan="2">Assigned fleet</th><th colspan="2">Planning &amp; execution</th>
          <th rowspan="2" class="actions-col">Actions</th></tr>
        <tr>
          <th pSortableColumn="runNumber">Identity <p-sortIcon field="runNumber"></p-sortIcon></th>
          <th pSortableColumn="status">Status &amp; profile <p-sortIcon field="status"></p-sortIcon></th>
          <th>Projects &amp; lanes</th>
          <th pSortableColumn="selectedReleaseCount">Order releases <p-sortIcon field="selectedReleaseCount"></p-sortIcon></th>
          <th>Drivers</th><th>Vehicles</th>
          <th pSortableColumn="horizonStart">Horizon &amp; routes <p-sortIcon field="horizonStart"></p-sortIcon></th>
          <th>Scenarios &amp; shipments</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-row>
        <tr>
          <td><button type="button" class="link-button primary" (click)="open(row)">{{ row.runNumber || 'Run #' + row.runId }}</button>
            @if (row.runName) { <small>{{ row.runName }}</small> }
            <small>Created {{ date(row.createdAt) }}</small></td>
          <td><p-tag [value]="label(row.status)" [severity]="severity(row.status)"></p-tag>
            <small>{{ row.profileName || 'Profile not available' }}</small>
            <small>{{ label(row.triggerType) }} trigger</small>
            @if (row.errorMessage) { <small class="warning">{{ row.errorMessage }}</small> }</td>
          <td>
            @if (row.projects.length) {
              @for (project of row.projects.slice(0, 2); track project.projectType + ':' + project.projectId) {
                <span class="stack-line"><strong>{{ project.projectNumber || project.projectName || 'Project #' + project.projectId }}</strong>
                  <small>{{ project.projectType }} project</small>
                  @if (project.projectNumber && project.projectName) { <small>{{ project.projectName }}</small> }
                </span>
              }
              @if (row.projects.length > 2) { <small>+{{ row.projects.length - 2 }} more projects</small> }
            } @else { <span class="muted">No project linked</span> }
            <small>{{ preview(row.origins, 1) }} to {{ preview(row.destinations, 1) }}</small>
          </td>
          <td><button type="button" class="link-button" (click)="toggleDetails(row.runId)"
              [attr.aria-expanded]="expandedRunIds.has(row.runId)">
              <i class="pi" [class.pi-chevron-down]="expandedRunIds.has(row.runId)" [class.pi-chevron-right]="!expandedRunIds.has(row.runId)"></i>
              {{ row.selectedReleaseCount }} selected</button>
            <small>{{ row.plannedReleaseCount }} planned · {{ row.unplannedReleaseCount }} unplanned</small>
            @if (row.blockedReleaseCount) { <small class="warning">{{ row.blockedReleaseCount }} blocked</small> }
            @for (release of row.releases.slice(0, 2); track release.releaseId) { <small>{{ release.releaseNumber }}</small> }
          </td>
          <td>
            @for (assignment of row.assignments.slice(0, 2); track assignment.routeId) {
              <span class="stack-line"><strong>{{ assignment.driverName || (assignment.driverId ? 'Driver #' + assignment.driverId : 'Driver unassigned') }}</strong>
                <small>Route {{ assignment.routeSequence || '—' }} · {{ assignment.routeStatus }}</small></span>
            }
            @if (!row.assignments.length) { <span class="muted">No routes assigned</span> }
            @if (row.assignments.length > 2) { <small>+{{ row.assignments.length - 2 }} more routes</small> }
          </td>
          <td>
            @for (assignment of row.assignments.slice(0, 2); track assignment.routeId) {
              <span class="stack-line"><strong>{{ assignment.vehiclePlateNumber || assignment.vehicleRegistrationNumber || assignment.vehicleLabel || (assignment.vehicleId ? 'Vehicle #' + assignment.vehicleId : 'Vehicle unassigned') }}</strong>
                <small>{{ assignment.vehicleTypeName || assignment.vehicleOwnershipType || 'Vehicle type not set' }}</small></span>
            }
            @if (!row.assignments.length) { <span class="muted">No vehicles assigned</span> }
            @if (row.assignments.length > 2) { <small>+{{ row.assignments.length - 2 }} more routes</small> }
          </td>
          <td><strong>{{ date(row.horizonStart) }}</strong><small>to {{ date(row.horizonEnd) }}</small>
            <small>{{ row.routeCount }} routes · {{ row.usedVehicleCount }} trucks</small></td>
          <td><strong>{{ row.scenarioCount }} scenarios</strong>
            <small>{{ row.shipmentCount }} shipments</small>
            @for (number of row.shipmentNumbers.slice(0, 2); track number) { <small>{{ number }}</small> }
            @if (row.status === 'APPLIED') { <small>Applied {{ date(row.appliedAt) }}</small> }
          </td>
          <td class="actions-col"><p-button label="Open" icon="pi pi-arrow-right" [outlined]="true" (onClick)="open(row)"></p-button></td>
        </tr>
        @if (expandedRunIds.has(row.runId)) {
          <tr class="detail-expansion"><td colspan="9">
            <div class="detail-heading"><strong>Scenarios</strong><span>{{ row.scenarioCount }} total</span></div>
            <div class="detail-grid">
              @for (scenario of row.scenarios; track scenario.scenarioId) {
                <div class="detail-card"><strong>{{ scenario.scenarioName || scenario.scenarioCode }}</strong>
                  <small>{{ label(scenario.status) }}{{ scenario.selected ? ' · Selected' : '' }} · {{ label(scenario.objective) }}</small>
                  <small>{{ scenario.plannedReleaseCount }} planned · {{ scenario.unplannedReleaseCount }} unplanned · {{ scenario.routeCount }} routes</small>
                </div>
              } @empty { <span class="muted">No scenarios generated yet.</span> }
            </div>
            @if (row.assignments.length) {
              <div class="detail-heading"><strong>Selected scenario routes</strong><span>{{ row.assignments.length }} shown</span></div>
              <div class="detail-grid">
                @for (assignment of row.assignments; track assignment.routeId) {
                  <div class="detail-card"><strong>Route {{ assignment.routeSequence || '—' }} · {{ assignment.routeStatus }}</strong>
                    <span>{{ assignment.driverName || 'Driver unassigned' }} · {{ assignment.vehiclePlateNumber || assignment.vehicleRegistrationNumber || assignment.vehicleLabel || 'Vehicle unassigned' }}</span>
                    <small>{{ date(assignment.startTime) }} – {{ date(assignment.endTime) }} · {{ assignment.releaseCount || 0 }} releases</small>
                  </div>
                }
              </div>
            }
            <div class="detail-heading"><strong>Order releases</strong><span>{{ row.releases.length }} shown</span></div>
            <div class="detail-grid">
              @for (release of row.releases; track release.releaseId) {
                <div class="detail-card"><div class="card-head"><a [routerLink]="['/transport-planning/releases', release.releaseId]">{{ release.releaseNumber }}</a>
                    <span>{{ label(release.status) }}</span></div>
                  <small>{{ release.projectNumber || release.projectName || 'No project' }} · {{ release.sourceNumber || release.sourceType || 'Source' }}</small>
                  <span>{{ release.originName || 'Pickup not set' }} → {{ release.destinationName || 'Dropoff not set' }}</span>
                  @if (release.reasonMessage) { <small class="warning">{{ release.reasonMessage }}</small> }
                </div>
              } @empty { <span class="muted">No releases were captured for this run.</span> }
            </div>
          </td></tr>
        }
      </ng-template>
      <ng-template pTemplate="emptymessage"><tr><td colspan="9" class="empty-cell">No bulk planning runs match the current filters.</td></tr></ng-template>
    </p-table>
  </app-page-data-panel>
</app-page-shell>
